<nav class="ui-bottom-navigation" [attr.aria-label]="ariaLabel()">
  @for (item of items(); track item.value) {
    <button
      type="button"
      class="ui-bottom-navigation__item"
      [class.ui-bottom-navigation__item--active]="isActive(item)"
      [attr.aria-label]="item.label"
      [attr.aria-current]="isActive(item) ? 'page' : null"
      [disabled]="item.disabled ?? false"
      (click)="onItemClick(item)"
    >
      @if (item.iconSrc) {
        <img
          class="ui-bottom-navigation__icon"
          [src]="item.iconSrc"
          alt=""
          aria-hidden="true"
          width="22"
          height="22"
        />
      }
    </button>
  }
</nav>
